export default "__VITE_ASSET__BbsLxXox__"